import React from "react";
import LoginImage from "../../assets/images/login.jpg";
import LoginForm from "./login/LoginForm";
import ForgotPasswordForm from "./forgot/ForgotPasswordForm";
import ChangePassword from "./forgot/ChangePassword";
import { useRecoilState } from "recoil";
import { LoginActiveView } from "global/LoginActiveView";

const AuthLayout = () => {
  const [loginActiveView, setLoginActiveView] = useRecoilState(LoginActiveView);

  const renderActiveView = () => {
    switch (loginActiveView) {
      case "login":
        return <LoginForm setLoginActiveView={setLoginActiveView} />;
      case "forgot-password":
        return <ForgotPasswordForm setLoginActiveView={setLoginActiveView} />;
      case "change-password":
        return <ChangePassword setLoginActiveView={setLoginActiveView} />;
      default:
        return <LoginForm setLoginActiveView={setLoginActiveView} />;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6">{renderActiveView()}</div>
        <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center">
          <img
            src={LoginImage}
            alt="Login_Image"
            style={{
              maxWidth: "100%",
              height: "100%",
              borderRadius: "50px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
